"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ChatReply = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M19.8550322,11.1463872 L23.2071068,14.4970009 L19.8548602,17.8510483 C19.6597029,18.0463104 19.3432055,18.0463954 19.1479433,17.8512381 C18.9525635,17.6558583 18.9525004,17.3392583 19.1477076,17.1438957 L21.2928932,14.9970009 L19,14.9999857 C16.790861,14.9999857 15,16.7908467 15,18.9999857 L15,19.9999857 L14,19.9999857 L14,18.9999857 C14,16.238562 16.2385763,13.9999857 19,13.9999857 L21.2928932,13.9970009 L19.1479627,11.8534567 C18.9527006,11.6583208 18.9525982,11.3418407 19.1477342,11.1465785 C19.343123,10.9511896 19.6597151,10.9511551 19.8550322,11.1463872 Z M18,5 C19.1045695,5 20,5.8954305 20,7 L20,9 L19,9 L19,7 C19,6.48716416 18.6139598,6.06449284 18.1166211,6.00672773 L18,6 L6,6 C5.48716416,6 5.06449284,6.38604019 5.00672773,6.88337887 L5,7 L5,15 C5,15.5128358 5.38604019,15.9355072 5.88337887,15.9932723 L6,16 L8,16 L8,18.923 L11.1930001,16.3607873 C11.4084065,16.1879351 11.723136,16.2223477 11.8960999,16.4376643 C12.049793,16.6289913 12.0397514,16.8988667 11.8844506,17.0779134 L11.8193654,17.1405273 L8.54480813,19.7699518 C8.13570592,20.0984553 7.53775837,20.0331171 7.20925491,19.6240149 C7.07381995,19.4553508 7,19.2455172 7,19.0292067 L7,17 L6,17 C4.8954305,17 4,16.1045695 4,15 L4,7 C4,5.8954305 4.8954305,5 6,5 L18,5 Z" })));
};
ChatReply.displayName = 'ChatReply';
exports.default = ChatReply;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ChatReply.js.map